import React from 'react';
import './style.scss';

export default function Toggle({ checked, onChange, label, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`toggle ${checked ? 'toggle--on' : ''}`}
      style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className="toggle__thumb" />
    </button>
  );
}
